<div class="edit-page-root-container reasons-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{getTitle()}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" *ngIf="editForm" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" appCodeInput
                                        [readonly]="menuInfo.id!==undefined && menuInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">code should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                        10.</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">name should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error>
                                </mat-form-field>
                            </div>

                        </div>
                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                            <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length
                                is
                                200.</mat-error>
                        </mat-form-field>
                        <div class="input-group" style="margin-bottom: 5px;">
                            <mat-checkbox formControlName="enable_h1_button">Enable H1 Button</mat-checkbox>
                            <mat-checkbox formControlName="enable_h2_button">Enable H2 Button</mat-checkbox>
                            <mat-checkbox formControlName="enable_h3_button">Enable H3 Button</mat-checkbox>
                            <!-- <mat-checkbox formControlName="is_active">Is Active</mat-checkbox> -->
                        </div>
                        <div class="input-group" style="margin-bottom: 10px;">
                            <mat-label style="margin-left: 10px;">Color</mat-label>
                            <mat-radio-group aria-label="Select an option" formControlName="color">
                                <mat-radio-button value="1"><img class="icon"
                                        src="assets/images/product-menu-colors/black.png"></mat-radio-button>
                                <mat-radio-button value="2"><img class="icon"
                                        src="assets/images/product-menu-colors/violet.png"></mat-radio-button>
                                <mat-radio-button value="3"><img class="icon"
                                        src="assets/images/product-menu-colors/blue.png"></mat-radio-button>
                                <mat-radio-button value="4"><img class="icon"
                                        src="assets/images/product-menu-colors/gold_metalic.png"></mat-radio-button>
                                <mat-radio-button value="5"><img class="icon"
                                        src="assets/images/product-menu-colors/green.png"></mat-radio-button>
                                <mat-radio-button value="6"><img class="icon"
                                        src="assets/images/product-menu-colors/orange.png"></mat-radio-button>
                                <mat-radio-button value="7"><img class="icon"
                                        src="assets/images/product-menu-colors/pink.png"></mat-radio-button>
                                <mat-radio-button value="8"><img class="icon"
                                        src="assets/images/product-menu-colors/purple.png"></mat-radio-button>
                                <mat-radio-button value="9"><img class="icon"
                                        src="assets/images/product-menu-colors/red_light.png"></mat-radio-button>
                                <mat-radio-button value="10"><img class="icon"
                                        src="assets/images/product-menu-colors/silver_metalic.png"></mat-radio-button>
                                <mat-radio-button value="11"><img class="icon"
                                        src="assets/images/product-menu-colors/burgundy.png"></mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <table class="table table-bordered" style="height: 150px;">
                            <thead>
                                <tr>
                                    <th>SL</th>
                                    <th style="text-align: left;">Code</th>
                                    <th style="text-align: left;">Name</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let dept of departments;let i=index;">
                                    <td style="text-align: center;">{{ i+1 }}</td>
                                    <td style="text-align: left;">{{ dept.code }}</td>
                                    <td style="text-align: left;">{{ dept.name }}</td>
                                    <td style="text-align: left;">
                                        <mat-checkbox [checked]="dept.isSelected"
                                            (change)="onDepartmentCheckboxChange($event, dept, i)"></mat-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="input-group" style="margin-top: 5px;">
                            <mat-checkbox formControlName="is_active">Active</mat-checkbox>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>